import { createTheme } from '@mui/material/styles';
import { colors } from '../styles/colors.js';
import { elevations } from '../styles/elevations.js';
import shippoTheme from '../styles/shippoTheme.js';

var chipTheme = createTheme(shippoTheme, {
    components: {
        MuiChip: {
            styleOverrides: {
                root: {
                    '&.MuiChip-sizeSmall': {
                        padding: `${shippoTheme.spacing(0.5)} ${shippoTheme.spacing(1)}`,
                        fontSize: '0.75rem',
                        fontWeight: 400,
                        lineHeight: 1.37,
                        gap: shippoTheme.spacing(0.5),
                        borderRadius: '30px',
                        '&.MuiChip-deletable': {
                            padding: `${shippoTheme.spacing(0.5)} ${shippoTheme.spacing(0.5)} ${shippoTheme.spacing(0.5)} ${shippoTheme.spacing(1)}`,
                            borderRadius: '40px',
                        },
                        '& *': {
                            padding: 0,
                            margin: 0,
                        },
                    },
                    '&.MuiChip-filledWarning': {
                        color: colors.yellow100,
                        backgroundColor: colors.accent.background.warning,
                        position: 'relative',
                        '& .MuiChip-deleteIconColorWarning': {
                            color: colors.yellow60,
                        },
                        '& .MuiChip-label': {
                            color: colors.text.default,
                        },
                        '& .custom-chip-icon.filled': {
                            backgroundColor: colors.yellow100,
                        },
                    },
                    '&.MuiChip-filledSuccess': {
                        color: colors.accent.foreground.success,
                        backgroundColor: colors.accent.background.success,
                        position: 'relative',
                        '& .MuiChip-label': {
                            color: colors.text.default,
                        },
                        '& .custom-chip-icon.filled': {
                            backgroundColor: colors.accent.foreground.success,
                        },
                    },
                    '&.MuiChip-filledInfo': {
                        color: colors.secondary,
                        backgroundColor: colors.secondaryHover,
                        position: 'relative',
                        '& .MuiChip-label': {
                            color: colors.text.default,
                        },
                        '& .custom-chip-icon.filled': {
                            backgroundColor: colors.secondary,
                        },
                    },
                    '&.MuiChip-filledError': {
                        color: colors.specialUse.hover,
                        backgroundColor: colors.accent.background.error,
                        position: 'relative',
                        '& .custom-chip-icon.filled': {
                            backgroundColor: colors.specialUse.hover,
                        },
                    },
                    '&.MuiChip-deletable': {
                        fontWeight: 500,
                        '&:hover': {
                            boxShadow: elevations[2],
                        },
                        '&:focus': {
                            boxShadow: `0px 0px 0px 4px ${colors.borderFocus}`,
                        },
                        '& .MuiChip-deleteIcon': {
                            color: colors.secondary,
                        },
                        '& .MuiChip-deleteIcon:hover': {
                            backgroundColor: colors.secondaryHover,
                            borderRadius: '50%',
                        },
                    },
                    '&.MuiChip-deletableColorDefault': {
                        color: colors.text.default,
                        backgroundColor: colors.backgroundDeemphasized,
                    },
                    '&.Mui-disabled': {
                        opacity: 0.5,
                    },
                },
            },
        },
    },
});

export { chipTheme as default };
//# sourceMappingURL=Chip.theme.js.map
